import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { LinkCardGrid } from "../../elements/LinkCardGrid";
import {
  CartIcon,
  RectangleListIcon,
  SettingsIcon,
} from "../../icons";
import { helpDocumentUrl, HelpDocument } from "./useHelpDocuments";

const documentIcons: Record<string, IconDefinition> = {
  "abandoned-baskets": CartIcon,
  automation: SettingsIcon,
  metadata: RectangleListIcon,
};

export function HelpOverview({
  documents,
}: {
  documents: HelpDocument[];
}) {
  return (
    <LinkCardGrid
      items={documents.map((document) => ({
        description: document.description,
        href: helpDocumentUrl(document.id),
        icon: documentIcons[document.id] ?? RectangleListIcon,
        title: document.title,
      }))}
    />
  );
}
